import cn from 'classnames';

export default function Input({
  label,
  name,
  defaultValue,
  ...inputProps
}: {
  label?: string;
  name: string;
  defaultValue?: string;
} & (
  | ({
      isTextarea: true;
    } & React.TextareaHTMLAttributes<HTMLTextAreaElement>)
  | ({
      isTextarea?: false;
    } & React.InputHTMLAttributes<HTMLInputElement>)
)) {
  const { isTextarea, className, ...rest } = inputProps;
  const sharedProps = {
    className: cn('rounded-md border border-neutral-200 p-2', className),
    id: name,
    name,
    defaultValue,
  };

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className="text-sm font-medium" htmlFor={name}>
          {label}
        </label>
      )}
      {isTextarea ? (
        <textarea
          {...sharedProps}
          {...(rest as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
        />
      ) : (
        <input
          type="text"
          {...sharedProps}
          {...(rest as React.InputHTMLAttributes<HTMLInputElement>)}
        />
      )}
    </div>
  );
}
